import api from '../api';

const BASE_URL = '/api/file-export';

/** Streams the export and saves it under the file name the server sent, matching RoomRepository's plan download. */
export function downloadFileExport(exportId: string): Promise<void> {
    let fileName: string | null = null;

    return api
        .get(`${BASE_URL}/${exportId}/download`)
        .then(response => {
            if (!response.ok) {
                return api.handle(response);
            }

            const disposition = response.headers.get('content-disposition');
            fileName = disposition?.split('filename=').reverse()[0] ?? null;

            return response.blob();
        })
        .then(blob => {
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.style.display = 'none';
            link.href = url;
            if (fileName) {
                link.download = fileName;
            }
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        })
        .catch(api.error);
}
